import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { Animated } from "react-animated-css";
import { connect } from "react-redux";
import "../../lib/css/components/loading-toast.scss";

const Loading = ({ loading }) => {
  const { actief, soort, message } = loading || { actief: false, soort: 'info', message: '' };
  const [isVisible, setIsVisible] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (actief) {
      setShouldRender(true);
      setIsVisible(true);
    } else {
      setIsVisible(false);
      // Wacht op de exit animatie voordat we het component verwijderen
      setTimeout(() => {
        setShouldRender(false);
      }, 600); // Tijd voor slideOutDown animatie
    }
  }, [actief]);

  if (!shouldRender) {
    return null;
  }

  // Icon mapping voor verschillende soorten berichten
  const getIcon = (type) => {
    switch (type) {
      case 'success':
        return 'fas fa-check-circle';
      case 'warning':
        return 'fas fa-exclamation-triangle';
      case 'danger':
      case 'error':
        return 'fas fa-exclamation-circle';
      case 'info':
      default:
        return 'fas fa-info-circle';
    }
  };

  return createPortal(
    <Animated
      animationIn="slideInUp"
      animationOut="slideOutDown" 
      className="loadingmessage toast-style"
      isVisible={isVisible}
      animationInDuration={400}
      animationOutDuration={500}
    >
      <div className={`toast show border-0`} role="alert">
        <div className="toast-header">
          <i className={`${getIcon(soort)} me-2 text-${soort}`}></i>
          <strong className="me-auto">Status</strong>
          <small className="text-muted">nu</small>
        </div>
        <div className="toast-body">
          {message}
        </div>
      </div>
    </Animated>,
    document.body
  );
}

const mapStateToProps = (state) => ({
  loading: state.loading?.message || { actief: false, soort: 'info', message: '' }
});

export default connect(mapStateToProps)(Loading);
